module.exports = __webpack_public_path__ + "static/img/xls.703f897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/xls.png
// module id = uW39
// module chunks = 4